/* BH 3D tiles — tikai deleģēti klikšķi uz document, tāpēc strādā arī tad,
   ja tēma pēc ielādes pārrenderē sekcijas DOM (klausītāji nepazūd). */
(function () {
  var MV_SRC = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js";
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  var prefetched = {};

  /* Bibliotēku (~110KB) lādējam tikai tad, kad lietotājs pieritina tuvu sekcijai —
     sākotnējo lapas ielādi un Core Web Vitals tas neietekmē. Klausāmies uz window
     (nevis sekcijas elementa), tāpēc tēmas DOM pārrenderēšana netraucē. */
  var libLoaded = false;
  function loadLib() {
    if (libLoaded) return;
    libLoaded = true;
    window.removeEventListener("scroll", checkNear);
    window.removeEventListener("resize", checkNear);
    if (!window.customElements.get("model-viewer")) {
      var s = document.createElement("script");
      s.type = "module";
      s.src = MV_SRC;
      document.head.appendChild(s);
    }
  }
  function checkNear() {
    var el = document.querySelector("[data-bh3d]");
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight + 800 && r.bottom > -800) loadLib();
  }
  window.addEventListener("scroll", checkNear, { passive: true });
  window.addEventListener("resize", checkNear);
  // bez ritināšanas pārbaudām tikai PĒC pilnas lapas ielādes (klusajā brīdī),
  // lai bibliotēkas ielāde nekad nekonkurē ar lapas sākotnējo ielādi
  function idleChecks() {
    [1200, 4000].forEach(function (d) { setTimeout(checkNear, d); });
  }
  if (document.readyState === "complete") idleChecks();
  else window.addEventListener("load", idleChecks);

  // iOS Quick Look lejupielādē USDZ tikai pogas spiešanas brīdī —
  // priekšielāde HTTP kešā padara atvēršanos manāmi ātrāku
  function prefetchUsdz(url) {
    if (!isIOS || !url || prefetched[url]) return;
    prefetched[url] = true;
    var link = document.createElement("link");
    link.rel = "prefetch";
    link.href = url;
    link.as = "fetch";
    document.head.appendChild(link);
  }

  function setModel(root, btn) {
    var mv = root.querySelector("model-viewer");
    if (!mv || !btn.dataset.glb) return;
    mv.setAttribute("src", btn.dataset.glb);
    mv.setAttribute("ios-src", btn.dataset.usdz || "");
    prefetchUsdz(btn.dataset.usdz);
  }

  function setActive(btn) {
    var group = btn.closest(".bh3d__group");
    if (!group) return;
    group.querySelectorAll(".bh3d__btn").forEach(function (b) {
      b.classList.toggle("is-active", b === btn);
    });
  }

  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest && ev.target.closest("[data-bh3d] .bh3d__btn");
    if (!btn) return;
    var root = btn.closest("[data-bh3d]");

    if (btn.hasAttribute("data-view")) {
      root.setAttribute("data-state-view", btn.dataset.view); // CSS rāda/slēpj izkārtojumu pogas
      setActive(btn);
      if (btn.dataset.view === "pack") {
        // komplekta skats atver aktīvo izkārtojumu (ja tādu izvēlējās iepriekš)
        var activeLayout = root.querySelector("[data-layout].is-active");
        setModel(root, activeLayout || btn);
      } else {
        setModel(root, btn);
      }
    } else if (btn.hasAttribute("data-layout")) {
      setActive(btn);
      setModel(root, btn);
    }
  });

  // priekšielādējam noklusētā (vienas flīzes) USDZ, tiklīdz sekcija ir lapā
  function prefetchInitial() {
    var mv = document.querySelector("[data-bh3d] model-viewer");
    if (mv) prefetchUsdz(mv.getAttribute("ios-src"));
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", prefetchInitial);
  } else {
    prefetchInitial();
  }
})();
